import { idGenerator } from "@/utils/idGenerator";

import type { NodeJson } from "@corca/data";

export type ParseResult = {
  text: string;
  nodes: NodeJson[];
  latexFound: boolean;
};

type ParseMarkdownWithLatexFunction = (
  text: string,
  noInline?: boolean,
  idGenerator?: () => string,
) => { text: string; nodes: NodeJson[]; latexFound: boolean };

export class MarkdownParser {
  static async create() {
    const { parseMarkdownWithLatex } = await import(/* webpackChunkName: "latex" */ "@corca/latex");
    return new MarkdownParser(parseMarkdownWithLatex);
  }

  constructor(private parseMarkdownWithLatex: ParseMarkdownWithLatexFunction) {}

  parse(input: string, noInline = false): ParseResult {
    return this.parseMarkdownWithLatex(input, noInline, idGenerator);
  }
}
